import API from '@/axios'
const Endpoint = '/perfis/convenios/'

export default {
	async getConvenio() {
		return await API.get(Endpoint).then((response) => response.data)
	},

	async visualizaConvenio(id) {
		return await API.get(Endpoint + id).then((response) => response.data)
	},

	async createAgreement(payload) {
		return await API.post(Endpoint, payload).then((response) => response.data)
	},

	async updateAgreement(payload, id) {
		return await API.put(Endpoint + id, payload).then((response) => response.data)
	},

	async deleteAgreement(id) {
		return await API.delete(Endpoint + id).then((response) => response)
	},

	async validarSigla(sigla) {
		return await API.post(Endpoint + 'validate/sigla', sigla).then((response) => response.data)
	},

	// Agreement Exam Addon methods
	async getAgreementExamAddons(agreementId, organizationId) {
		return await API.get(
			`${Endpoint}${agreementId}/exam-addons?organizationId=${organizationId}`
		).then((response) => response.data)
	},

	async createAgreementExamAddon(agreementId, payload, organizationId) {
		return await API.post(
			`${Endpoint}${agreementId}/exam-addons?organizationId=${organizationId}`,
			payload
		).then((response) => response.data)
	},

	async updateAgreementExamAddon(agreementId, addonId, payload, organizationId) {
		return await API.put(
			`${Endpoint}${agreementId}/exam-addons/${addonId}?organizationId=${organizationId}`,
			payload
		).then((response) => response.data)
	},

	async deleteAgreementExamAddon(agreementId, addonId, organizationId) {
		return await API.delete(
			`${Endpoint}${agreementId}/exam-addons/${addonId}?organizationId=${organizationId}`
		).then((response) => response.data)
	},
}
